import { HomePage } from 'src/pages'

const Home = () => {
  return <HomePage />
}

export default Home
